module.exports = __webpack_public_path__ + "img/search-white.ee2ee4fb.svg";